(() => {
  'use strict';

  const TRACK = document.querySelector('.nextdev--review-ticker--track');
  if (TRACK != null) {
    const REVIEWS = TRACK.querySelector('.nextdev--review-ticker--reviews:first-child');
    const scrollWidth = REVIEWS.offsetWidth;
    
    const style = document.createElement('style');
    style.textContent = `@keyframes review-ticker-scroll { 0% { transform: translateX(0); } 100% { transform: translateX(-${scrollWidth}px); } }`;
    TRACK.appendChild(style);
  }
})();
